import { useLanguage } from '@/contexts/LanguageContext';
import { OrgAlert } from '@/components/common/OrgAlert';
import { CustomerPortalButton } from '@/components/billing/CustomerPortalButton';

/**
 * Shared content for the past due subscription alert.
 * Used in OrgAlerts and EntitlementsTable popover.
 */
export function PastDueAlertContent() {
  const { t } = useLanguage();

  return (
    <OrgAlert variant="error" title={t.billing.pastDueAlert.alertTitle}>
      <p className="text-xs">{t.billing.pastDueAlert.description}</p>
      <div className="mt-auto self-end">
        <CustomerPortalButton
          variant="outline"
          size="sm"
          className="border-error text-error hover:opacity-90"
        />
      </div>
    </OrgAlert>
  );
}
